(function($) {

	'use strict';

	function init() {
        initListeners();
	};

    function initListeners() {

        // Ouverture / Fermeture du menu de sélection des catégories au clic
        $('.listing__filter').click(function() {
            $(this).find('.listing__filter__select').toggleClass('active');
        });

        // Soumission du formulaire lors du clic sur une catégorie
        $('.select-item').mouseup(function(e) {
            $(this).find('input').prop('checked', true);
			window.location = $(this).find('input').val();
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
